import Api from './baseApi';

export default {
  searchPartnerBanks: (params) => {
    let url = '/api/partnerbanks?v=1';
    if (params.search) url += `&q=${params.search}`;
    if (params.status) url += `&status=${params.status}`;
    if (params.tenantId) url += `&tenantId=${params.tenantId}`;
    if (params.companyId) url += `&companyId=${params.companyId}`;
    return Api.get(url);
  },
  getAllPartnerBanks: () => Api.get('/api/partnerbanks/all'),
  getPartnerBank: (id) => Api.get(`/api/partnerbanks/${id}`),
  putPartnerBank: (bank) => Api.put(`/api/partnerbanks/${bank.id}`, bank),
  deletePartnerBank: (bank) => Api.delete(`/api/partnerbanks/${bank.id}`),
  postPartnerBank: (bank) => Api.post(`/api/partnerbanks`, bank),
  cashAmountUpdate: (bankName, cashAmount) =>
    Api.post(`/api/partnerbanks/cash-amount-update`, { bankName, cashAmount }),
  buyGold: (bankName, payment, gram, companyId, receiptUrl = '', date = null) =>
    Api.post(`/api/partnerbanks/buy-gold`, { bankName, payment, gram, companyId, receiptUrl, date }),
  transferCashToAnotherBank: (fromBankName, toBankName, amount, transferFee = 0, companyId, receiptUrl = '') =>
    Api.post(`/api/partnerbanks/transfer-cash-to-another-bank`, { fromBankName, toBankName, amount, transferFee, companyId, receiptUrl }),
  transferGoldToAnotherBank: (fromBankName, toBankName, gram, transferFee = 0, companyId, receiptUrl = '') =>
    Api.post(`/api/partnerbanks/transfer-gold-to-another-bank`, { fromBankName, toBankName, gram, transferFee, companyId, receiptUrl }),
  transferGoldBetweenCompanies: (payload) =>
    Api.post(`/api/partnerbanks/transfer-gold-between-companies`, payload),
  transferCashBetweenCompanies: (payload) =>
    Api.post(`/api/partnerbanks/transfer-cash-between-companies`, payload),
  processExternalPayments: (bankName, payment, paymentType, companyId, paymentTypeOtherText = '') =>
    Api.post(`/api/partnerbanks/external-payments`, { bankName, payment, paymentType, companyId, paymentTypeOtherText }),
  addIncomingPayment: (bankName, amount, companyId, date = null) =>
    Api.post(`/api/partnerbanks/incoming-payment`, { bankName, amount, companyId, date }),
  dailyPurchasedGoldGroupedByBank: (companyId) =>
    Api.get(`/api/partnerbanks/daily-purchased-gold`, { params: { companyId } }),
  calculateDailyGoldStock: (companyId) =>
    Api.get(`/api/partnerbanks/daily-gold-stock`, { params: { companyId } }),
  getExpectedPaymentCheckLists: (companyId) =>
    Api.get(`/api/partnerbanks/expected-payment-checklists`, { params: { companyId } }),
  getExternalPaymentLogs: (date) =>
    Api.get(`/api/partnerbanks/external-payment-logs`, { params: { date } }),
  getSnapshots: (date) =>
    Api.get(`/api/partnerbanks/snapshots`, { params: { date } }),
};
